/* kovoo single-page helpers */
(() => {
  const home = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  const samePage = (a) => {
    try {
      const u = new URL(a.getAttribute('href'), location.href);
      return u.hash && u.hash.length > 1 && u.origin === location.origin && (u.pathname === location.pathname || (u.pathname === home && location.pathname === home));
    } catch (e) { return false; }
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.hasAttribute('data-open') || !samePage(a)) return;
    const id = decodeURIComponent(new URL(a.getAttribute('href'), location.href).hash.slice(1));
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    document.querySelectorAll('.is-open').forEach((w) => { if (window.theme && window.theme.closeDrawer) window.theme.closeDrawer(w); else w.classList.remove('is-open'); });
    document.body.classList.remove('no-scroll');
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { history.replaceState(null, '', '#' + id); } catch (err) { /* noop */ }
    });
  }, true);

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-break]')) {
      const card = e.target.closest('.break');
      if (card) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
    }
    /* color-pair picker (preview mode, before real variants exist) */
    if (e.target.matches('[data-vc-input]')) {
      const wrap = e.target.closest('[data-vc-preview]');
      const out = wrap && wrap.querySelector('[data-vc-selected]');
      if (out) out.textContent = e.target.value;
    }
  });

  let lastSubmit = null;
  document.addEventListener('submit', (e) => { if (e.target.matches('form[data-ajax-cart]')) lastSubmit = e.target; }, true);
  document.addEventListener('cart:updated', () => {
    document.querySelectorAll('[data-open="CartDrawer"]').forEach((el) => { el.classList.remove('cart-bump'); void el.offsetWidth; el.classList.add('cart-bump'); });
    const btn = lastSubmit && lastSubmit.querySelector('[data-add-btn]');
    lastSubmit = null;
    if (!btn) return;
    btn.classList.add('is-added');
    setTimeout(() => btn.classList.remove('is-added'), 1600);
  });
})();
